import React from "react";
import "./ui.scss";

/**
 * Infinite horizontal marquee band. Duplicates content so it loops seamlessly.
 *  - items: array of strings
 *  - speed: seconds per loop (lower = faster)
 *  - reverse: scroll direction
 */
export default function Marquee({ items = [], speed = 30, reverse = false, className = "" }) {
  const sep = "✦";
  const row = (
    <div className="marquee__row" aria-hidden="true">
      {items.map((t, i) => (
        <span className="marquee__item" key={i}>
          {t}
          <span className="marquee__sep">{sep}</span>
        </span>
      ))}
    </div>
  );

  return (
    <div className={`marquee ${className}`}>
      <div
        className="marquee__track"
        style={{ animationDuration: `${speed}s`, animationDirection: reverse ? "reverse" : "normal" }}
      >
        {row}
        {row}
      </div>
    </div>
  );
}
